import { getLicenseParamsForRouteQuery, goto, IMatchWithContext, refreshRoute } from '../../utils/router';

import { Location, ObjectStringMap, Router } from 'found';
import * as qs from 'query-string';

import { BrowsePagePath } from '../../components/pages/browse/Browse';
import { diff } from '../../utils/array';
import { BudgetFilter } from './budgetFilter';
import { LicenseFilter } from './license';
import { getSearchAsArray, SearchFilter } from './searchFilters';
import { SortOrderSerializer } from './sortOrder';
import { TempoFilter } from './tempoFilter';
import { IQueryStringState, QueryStringParam } from './types';

/**
 * getEncodedQuery
 * Make sure to encode only the search filters
 */
export function getEncodedQuery(query: ObjectStringMap) {
  const encodedQuery = { ...query };

  if (QueryStringParam.Search in query) {
    encodedQuery[QueryStringParam.Search] = SearchFilter.serialize(getSearchAsArray(query));
  }

  return encodedQuery;
}

export function replaceQueryString(query: ObjectStringMap, location: Location, router: Router) {
  const difference = diff(qs.parse(location.search), query);
  if (!(QueryStringParam.License in difference) && location.pathname !== BrowsePagePath) {
    // Redirect to browse page if a search is initiated from elsewhere in the app
    goto(BrowsePagePath, query, router);
  } else {
    refreshRoute(location, router, query);
  }
}

export function updateQueryString(query: ObjectStringMap, location: Location, router: Router) {
  const newQuery = {
    ...qs.parse(location.search) as ObjectStringMap,
    ...query,
  };

  if (!(QueryStringParam.License in query) && location.pathname !== BrowsePagePath) {
    goto(BrowsePagePath, newQuery, router);
  } else {
    refreshRoute(location, router, newQuery);
  }
}

export function getQueryStringStateForRoute(match: IMatchWithContext): Required<IQueryStringState> {
  const locationQuery = match.location.query;
  const { filters, query, taxonomy_query } = SearchFilter.unserialize(locationQuery);
  return {
    taxonomy_query: taxonomy_query as any,
    filters: {
      ...filters,
      budget: BudgetFilter.unserialize(locationQuery),
      tempo: TempoFilter.unserialize(locationQuery),
    },
    license_params: getLicenseParamsForRouteQuery(match),
    sort: SortOrderSerializer.unserialize(locationQuery),
    query,
  };
}

export function generateQueryStringFromState(state: IQueryStringState | undefined): ObjectStringMap {
  if (state) {
    return {
      [QueryStringParam.License]: LicenseFilter.serialize(state.license_params || []),
      [QueryStringParam.Search]: SearchFilter.serialize(SearchFilter.searchParamsToArray(state)),
      [QueryStringParam.Budget]: BudgetFilter.serialize(state.filters!.budget),
      [QueryStringParam.Tempo]: TempoFilter.serialize(state.filters!.tempo),
      [QueryStringParam.SortOrder]: SortOrderSerializer.serialize(state.sort!),
      [QueryStringParam.Similarity]: state.filters!.similarity ? state.filters!.similarity!.track_id : '',
    };
  }

  return {};
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/helpers.ts